import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Stethoscope, Users } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1758691463331-2ac00e6f676f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxwZWRpYXRyaWNpYW4lMjBkb2N0b3IlMjBjaGlsZHxlbnwwfHx8fDE3ODMwMDIyMjJ8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-[#E2E8F0]"
    >
      <div className="absolute inset-0 bg-grid mask-fade-b pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.22em] text-[#0055FF] mb-6">
              <span className="h-1.5 w-1.5 rounded-full bg-[#0055FF]" />
              Expert Pediatric Care in Jaipur
            </div>

            <h1
              data-testid="hero-heading"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0A192F] leading-[1.05]"
            >
              Empowering every child to reach{" "}
              <span className="relative inline-block">
                <span className="relative z-10">their full potential.</span>
                <span className="absolute inset-x-0 bottom-1 h-3 bg-[#E6F5EE] -z-0"></span>
              </span>
            </h1>

            <p className="mt-6 text-base sm:text-lg text-[#475569] max-w-2xl leading-relaxed">
              SHUNYA CDC is a modern, clinical child development center in
              Jaipur — offering evidence-based therapies designed around your
              child&apos;s unique developmental journey.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/book"
                data-testid="hero-book-btn"
                className="inline-flex items-center gap-2 bg-[#0055FF] text-white hover:bg-[#0044CC] rounded-full px-6 py-3 font-medium transition-colors"
              >
                Book a Consultation
                <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href="#services"
                data-testid="hero-services-btn"
                className="inline-flex items-center bg-white text-[#0A192F] border border-[#E2E8F0] hover:bg-[#F8FAFC] rounded-full px-6 py-3 font-medium transition-colors"
              >
                Explore Our Services
              </a>
            </div>

            <p className="mt-10 text-sm text-[#475569] leading-relaxed whitespace-nowrap overflow-x-auto">
              📞 Easy Appointment Booking &nbsp; 🤝 Compassionate Care &nbsp; 📍 Convenient Jaipur Location
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-[#E6F5EE] -z-10" />
              <img
                src={HERO_IMG}
                alt="Pediatric therapist working with a child"
                className="w-full aspect-[4/5] object-cover rounded-2xl border border-[#E2E8F0] shadow-sm"
                data-testid="hero-image"
              />

              <div className="absolute -left-4 bottom-6 hidden sm:block">
                <div className="bg-white border border-[#E2E8F0] rounded-xl p-4 shadow-sm w-56">
                  <div className="flex items-center gap-2 text-[#0055FF]">
                    <ShieldCheck className="h-4 w-4" />
                    <span className="text-xs font-bold uppercase tracking-widest">
                      Evidence-based
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-[#0F172A] font-medium leading-snug">
                    Individualized plans backed by clinical assessment.
                  </p>
                </div>
              </div>

              <div className="absolute -right-3 top-6 hidden sm:block">
                <div className="bg-white border border-[#E2E8F0] rounded-xl p-4 shadow-sm w-52">
                  <div className="flex items-center gap-2 text-[#0055FF]">
                    <Users className="h-4 w-4" />
                    <span className="text-xs font-bold uppercase tracking-widest">
                      Multi-disciplinary
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-[#0F172A] font-medium leading-snug">
                    Speech Therapy, Occupational Therapy, Special Education and Child & Parent Counselling UNDER ONE ROOF.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-heading text-2xl sm:text-3xl font-bold text-[#0A192F]">
        {value}
      </div>
      <div className="text-xs text-[#475569] mt-1">{label}</div>
    </div>
  );
}
